import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { portalQuery } from '@api/api.config';

import { LOCAL_STORAGE_AUTH_KEY } from '@util/constants/local-storage.constants';

type BaseQueryType = ReturnType<typeof fetchBaseQuery>;
type BaseQueryAuthType = (url: string) => BaseQueryType;

export const portalQueryAuth: BaseQueryAuthType = (url: string) => async (args, api, extraOptions) => {
  const result = await portalQuery(url)(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    window.location.href = '/login';
    localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY);
  }
  return result;
};
